import { Button } from 'primereact/button';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../utils/AuthProvider';

const NotFound = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { isLoggedIn } = useAuth();

    return (
        //düzenlenecek
        <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 dark:bg-gray-800 p-5">
            <div className="bg-white dark:bg-gray-700 rounded-lg shadow-lg p-8 max-w-md w-full text-center">
                <h1 className="text-6xl font-bold text-logo-mid dark:text-gray-300 mb-4">404</h1>
                <h2 className="text-2xl font-bold text-logo-dark dark:text-gray-400 mb-6">
                    {t('pageNotFound')}
                </h2>
                <p className="text-gray-600 dark:text-gray-400 mb-8">
                    {t('pageNotFoundMessage')}
                </p>
                <div className="flex justify-center gap-4">
                    <Button
                        label={t('goBack')}
                        icon="pi pi-arrow-left"
                        className="bg-logo-light hover:bg-logo-mid dark:bg-gray-600 dark:hover:bg-gray-500 px-3 py-2 rounded-lg text-white"
                        onClick={() => navigate(-1)}
                    />
                    <Button
                        label={isLoggedIn ? t('goHome') : t('goLogin')}
                        icon={isLoggedIn ? "pi pi-home" : "pi pi-sign-in"}
                        className="bg-logo-mid hover:bg-logo-dark dark:bg-gray-500 dark:hover:bg-gray-600 px-3 py-2 rounded-lg text-white"
                        onClick={() => { isLoggedIn ? navigate('/homepage') : navigate('/login') }}
                    />
                </div>
            </div>
        </div>
    );
};

export default NotFound;